import type { PaymentMethodCode } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

import { PaymentAdvertisingSpot } from '../../types/PaymentAdvertisingSpot'

import { KlarnaPlacementKey } from './KlarnaThirdPartyAdvertisement.constants'

export const KLARNA_PAYMENT_METHODS: PaymentMethodCode[] = [
  'klarna_slice_it',
  'klarna_pay_later',
]

export const KLARNA_ADVERTISEMENT_SETTINGS = {
  [PaymentAdvertisingSpot.PRODUCT]: {
    placementKey: KlarnaPlacementKey.PRODUCT,
  },
  [PaymentAdvertisingSpot.CART]: {
    placementKey: KlarnaPlacementKey.PRODUCT,
  },
  [PaymentAdvertisingSpot.ORDERS]: {
    placementKey: KlarnaPlacementKey.SITEWIDE,
  },
}

export const KLARNA_LIBRARY_RENDERING_TIMEOUT = 30000
